import { Component, Input, OnInit } from '@angular/core';
import { QuickLink } from '../../models';
import { CONFIG } from '../../../config';

@Component({
    selector: 'rms-quick-links',
    templateUrl: './quick-links.component.html',
    styleUrls: ['./quick-links.component.scss'],
    standalone: false
})
export class QuickLinksComponent implements OnInit {

  @Input() linksList: Array<QuickLink>;
  public dropdownOpen = false;

  constructor() { }

  ngOnInit() {
  }

  public openLink(item: QuickLink): void {
    this.dropdownOpen = false;
    if (!this.isSafeHref(item.link.href)) {
      return;
    }
    window.open(item.link.href, '_blank', 'noopener,noreferrer');
  }

  public openDropDown(): void {
    this.dropdownOpen = true;
  }

  public closeDropDown(): void {
    this.dropdownOpen = false;
  }

  /**
   * Restricts window.open navigation to http/https (or protocol-relative)
   * URLs, since stored hrefs are user-supplied and never scheme-validated
   * server-side. Blocks javascript: and other script-executing schemes.
   */
  private isSafeHref(href: string): boolean {
    return !!href && new RegExp(CONFIG.absoluteUrlPatter, 'i').test(href);
  }

}
